import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../../supabase";
import { useTranslation } from "react-i18next";
import AuthSplit from "../../components/AuthSplit";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSend() {
    setMsg("");
    setError("");
    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/update-password?reset=1`,
    });

    setLoading(false);

    if (error) {
      setError(t("auth_page.request_failed"));
      return;
    }

    setMsg(t("auth_page.reset_email_notice"));
  }

  return (
    <AuthSplit
      hero1={t("auth_split.forgot_hero1")}
      hero2={t("auth_split.forgot_hero2")}
      lead={t("auth_split.forgot_lead")}
      title={t("forgot_password")}
      sub={t("auth_split.forgot_sub")}
    >
      {error && <div className="auth-error-text">{error}</div>}
      {msg && <div className="auth-success-text">{msg}</div>}

      <form
        className="auth-form"
        onSubmit={(e) => {
          e.preventDefault();
          if (!loading && email) handleSend();
        }}
      >
        <div className="ca-field">
          <label className="ca-label" htmlFor="forgot-email">{t("email")}</label>
          <input
            id="forgot-email"
            className="auth-input"
            type="email"
            autoComplete="email"
            placeholder={t("auth_page.enter_registered_email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <p className="ca-note">{t("auth_split.forgot_note")}</p>

        <button className="auth-btn" type="submit" disabled={loading || !email}>
          {loading ? t("auth_page.sending") : t("auth_page.send_reset_email")}
        </button>
      </form>

      <div className="auth-links">
        <Link to="/login">{t("auth_page.back_to_login")}</Link>
      </div>
    </AuthSplit>
  );
}
